module.exports = __webpack_public_path__ + "img/calendar-disable-1.6d78e1fc.svg";